module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/TJ-06a5ddb8140a6297c9d05defad36b316.png";